import { render } from "./Game.vue?vue&type=template&id=1269d306&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=1269d306&lang=scss&scoped=true"

import exportComponent from "D:\\Softsion\\Vue\\web-app-topup\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1269d306"]])

export default __exports__